module.exports = __webpack_public_path__ + "img/tiktok.6c138d65.svg";